import { useEffect, useRef } from 'react';
import { useAuth } from '@/hooks/useAuth';
import { usePublicCountry } from '@/contexts/PublicCountryContext';
import { refreshTenantQueries } from '@/utils/queryConfig';

/**
 * When the header country changes, refetch every mounted query so Registry,
 * User Management, and public Services show that country without a reload.
 */
export function TenantQueryRefresh() {
  const { countryId: authCountryId } = useAuth();
  const { countryId: publicCountryId } = usePublicCountry();
  const tenantKey = authCountryId || publicCountryId || null;
  const previousKey = useRef<string | null | undefined>(undefined);

  useEffect(() => {
    if (previousKey.current === undefined) {
      previousKey.current = tenantKey;
      return;
    }

    if (previousKey.current === tenantKey) {
      return;
    }

    previousKey.current = tenantKey;
    void refreshTenantQueries();
  }, [tenantKey]);

  return null;
}
